import { ContentWrap, Responsive } from '../../../ui';
import { ISocialLinksProps, SocialLinks } from '../social-links/SocialLinks';

interface IFooterSocialsSection {
	socialLinks: ISocialLinksProps;
}

export default function FooterSocialsSection({
	socialLinks,
}: IFooterSocialsSection) {
	const isMobileXL = Responsive.useMatchesBreakpoint('mobileXL');

	return !isMobileXL ? (
		<ContentWrap>
			<SocialLinks {...socialLinks} />
		</ContentWrap>
	) : (
		<>
			<SocialLinks {...socialLinks} />
		</>
	);
}
